// 📬 Suivi client — badge « Vu le … (N×) » / « Non vu » (listes) et bloc détaillé (détail soumission/facture).
import { Badge } from '@/components/ui/badge';
import { Eye, EyeOff } from 'lucide-react';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString('fr-CA', { dateStyle: 'medium', timeStyle: 'short' }) : '—');

export function BadgeSuiviClient({ suivi, testid = 'badge-suivi-client' }) {
  const s = suivi || {};
  if (!s.vu) {
    return (
      <Badge variant="outline" className="text-slate-500 border-slate-300" data-testid={`${testid}-non-vu`}>
        <EyeOff className="w-3 h-3 mr-1" />Non vu
      </Badge>
    );
  }
  return (
    <Badge className="bg-emerald-100 text-emerald-800 border border-emerald-300" data-testid={`${testid}-vu`} title={`Première ouverture : ${fmt(s.premiere_ouverture)}`}>
      <Eye className="w-3 h-3 mr-1" />Vu le {new Date(s.derniere_ouverture).toLocaleDateString('fr-CA')} ({s.nb_ouvertures}×)
    </Badge>
  );
}

export function BlocSuiviClient({ suivi, relances = [], testid = 'bloc-suivi-client' }) {
  const s = suivi || {};
  return (
    <div className="rounded-lg border bg-slate-50 p-3 text-sm space-y-1" data-testid={testid}>
      <div className="flex items-center justify-between">
        <p className="font-semibold text-slate-800">Suivi client</p>
        <BadgeSuiviClient suivi={s} testid={`${testid}-badge`} />
      </div>
      <p data-testid={`${testid}-premiere`}>Première ouverture : <strong>{fmt(s.premiere_ouverture)}</strong></p>
      <p data-testid={`${testid}-derniere`}>Dernière ouverture : <strong>{fmt(s.derniere_ouverture)}</strong> · {s.nb_ouvertures || 0} ouverture(s)</p>
      <p data-testid={`${testid}-pdf`}>Dernier PDF téléchargé : <strong>{fmt(s.dernier_telechargement_pdf)}</strong> · {s.nb_telechargements || 0} téléchargement(s)</p>
      {relances.length > 0 && (
        <div className="pt-2 border-t mt-2" data-testid={`${testid}-relances`}>
          <p className="font-semibold text-slate-800">Relances</p>
          {relances.map((r) => (
            <p key={r.id} className="text-xs text-slate-600" data-testid={`relance-historique-${r.id}`}>
              {fmt(r.envoyee_a || r.ignoree_a || r.annulee_a || r.proposee_a)} — {LIBELLES_RELANCE[r.statut] || r.statut}
              {r.raison_annulation ? ` (${r.raison_annulation})` : ''}{r.envoyee_par?.email ? ` par ${r.envoyee_par.email}` : ''}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}

export const LIBELLES_RELANCE = { proposee: 'Proposée (à approuver)', envoyee: 'Envoyée', ignoree: 'Ignorée', annulee_auto: 'Annulée automatiquement' };
